import request from "@/utils/request";

// 新建栏目
export function createColumn(data) {
  return request({
    url: "/newMall/healthColumn/createHealthColumn",
    method: "post",
    data
  });
}

// 修改栏目
export function updateColumn(data) {
  return request({
    url: "/newMall/healthColumn/updateHealthColumn",
    method: "post",
    data
  });
}

// 排序健康科普栏目
export function sortHealthColumn(data) {
  return request({
    url: "/newMall/healthColumn/sortHealthColumn",
    method: "post",
    data
  });
}

// 健康栏目列表
export function getHealthColumnList(params) {
  return request({
    url: "/newMall/healthColumn/getHealthColumnList",
    method: "get",
    params
  });
}

// 健康栏目详情
export function getHealthColumnDetail(params) {
  return request({
    url: "/newMall/healthColumn/getHealthColumn",
    method: "get",
    params
  });
}

// 批量启用健康科普栏目
export function enableHealthColumn(data) {
  return request({
    url: "/newMall/healthColumn/batchEnableHealthColumn",
    method: "post",
    data
  });
}

// 批量禁用健康科普栏目
export function disableHealthColumn(data) {
  return request({
    url: "/newMall/healthColumn/batchDisableHealthColumn",
    method: "post",
    data
  });
}

// 批量删除健康科普栏目
export function deleteHealthColumn(data) {
  return request({
    url: "/newMall/healthColumn/batchDeleteHealthColumn",
    method: "post",
    data
  });
}

// 根据类型获取标签列表
export function getTagByType(data) {
  return request({
    url: "/newMall/tag/queryTagByType",
    method: "post",
    data
  });
}

// 标签创建
export function createTag(data) {
  return request({
    url: "/newMall/tag/create",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/shop/popcolumnManage.js